<template>
  <div
    class="body-container pt-30"
    :class="{ isTablet: isTablet }"
    style="background-color: white"
  >
    <div class="container-fluid minHeight-120">
      <div class="font-16 mb-40">
        <span class="pdfTitle">家庭保單健檢規劃書列印</span>
        <span @click="instructions" class="text-orange btn">
          <i class="icon-attach i-20 textTop"></i>
          <u>使用說明</u>
        </span>
      </div>
      <div class="text-black mb-30">
        <strong class="font-24">步驟1/2:選擇報表</strong>
      </div>

      <!-- ------------------------------------------------可選報表------------------------------------------------ -->
      <div class="text-green mb-30">
        <strong class="font-20">可選報表</strong>
        <button
          type="button"
          class="btn btn-default btn-sm baseLine"
          @click="selectAll(true)"
          v-show="!isSelectPdf"
        >
          選取所有報表
        </button>
        <button
          v-show="isSelectPdf"
          type="button"
          class="btn btn-default btn-sm baseLine"
          @click="selectAll(false)"
        >
          清空所有報表
        </button>
        <button
          type="button"
          class="btn btn-default btn-sm baseLine"
          @click="selectCommonlyUsed()"
        >
          選取所有常用報表
        </button>
        <button
          v-if="recommendReports.length > 0"
          type="button"
          class="btn btn-default btn-sm baseLine"
          @click="selectRecommend()"
        >
          選取推薦報表
        </button>
        <span
          v-if="
            isSelectPdf &&
            policyOverWarn === true &&
            familyInfoListDrag.length === familyInfoList.length
          "
          class="text-danger"
        >
          *因家戶保單數量龐大，若全選可能導致報表產製所需時間過久或無法順利產出，建議斟酌所勾選之報表張數。
        </span>
      </div>
      <div v-for="(item, index) in familyInfoList" :key="index">
        <div class="text-black mb-15 form-inline">
          <span :class="`checkbox m-0`">
            <input
              v-model="item.theadAll"
              @click="changeInput(item)"
              type="checkbox"
              :value="item.reportType"
              :id="`thead${index}`"
            />
            <label :for="`thead${index}`"></label>
          </span>
          <!-- 20211202 判斷完整版/精簡版調色 -->
          <template
            v-if="
              item.reportTitle.includes('完整') ||
              item.reportTitle.includes('個人')
            "
          >
            <strong class="font-16">{{
              item.reportTitle.split("(")[0]
            }}</strong>
            <strong class="font-16" style="color: #ff1989">{{
              item.reportTitle.substring(
                item.reportTitle.indexOf("("),
                item.reportTitle.indexOf(")") + 1
              )
            }}</strong>
            <strong
              class="font-16"
              style="color: rgb(65 169 1)"
              v-if="item.reportTitle.includes('-客服列印')"
              >{{
                item.reportTitle.substring(
                  item.reportTitle.indexOf("-客服列印")
                )
              }}</strong
            >
          </template>
          <template v-else-if="item.reportTitle.includes('精簡')">
            <strong class="font-16">{{
              item.reportTitle.split("(")[0]
            }}</strong>
            <strong class="font-16" style="color: #0000ff">{{
              item.reportTitle.substring(
                item.reportTitle.indexOf("("),
                item.reportTitle.indexOf(")") + 1
              )
            }}</strong>
          </template>
          <template v-else-if="item.reportTitle.includes('-客服列印')">
            <strong class="font-16">{{
              item.reportTitle.split("-客服列印")[0]
            }}</strong>

            <strong
              class="font-16"
              style="color: rgb(65 169 1)"
              v-if="item.reportTitle.includes('-客服列印')"
              >{{
                item.reportTitle.substring(
                  item.reportTitle.indexOf("-客服列印")
                )
              }}</strong
            >
          </template>
          <template v-else>
            <strong class="font-16">{{ item.reportTitle }}</strong>
          </template>
          <span
            @click="openPdfInfo(item.reportTitle, item.reportType)"
            class="text-green text-underline ml-10 mr-14"
          >
            說明
          </span>
          <a
            role="button"
            :class="`btn btn-default btn-sm btn-common mr-20 ${
              item.commonlyUsed ? 'btn-common-active' : 'btn-common'
            }`"
            @click="setCommonlyUsed(item)"
          >
            常用
          </a>
        </div>
        <hr />
      </div>
      <!-- ------------------------------------------------可選報表------------------------------------------------ -->
      <!-- ----------------------------------------------報表列印順序----------------------------------------------- -->
      <div>
        <div class="text-green mt-5 font-20 rwd-mt">
          <strong>拖曳調整報表列印順序</strong>
          <button
            type="button"
            @click="sortDragItem()"
            class="btn btn-default btn-sm"
            style="vertical-align: middle"
          >
            回復預設排序
          </button>
        </div>
        <div v-if="familyInfoListDrag.length > 0" style="width: 50%">
          <draggable
            :list="familyInfoListDrag"
            :disabled="!enabled"
            v-bind="dragOptions"
            ghost-class="ghost"
            :move="checkMove"
            @start="dragging = true"
            @end="dragging = false"
          >
            <div
              class="d-flex flex-row rwd-radio-block"
              v-for="(element, index) in familyInfoListDrag"
              :key="element.name"
            >
              <div class="pdf-index">{{ index + 1 }}</div>
              <div class="mr-auto pdfBtn">
                <i class="fas fa-arrows-alt text-gray mr-2"></i>
                {{ element.reportTitle }}
              </div>
            </div>
          </draggable>
        </div>
        <div v-else class="noPDFListData mt-4 rwd-mt">
          尚未選取任何報表或列印對象
        </div>
      </div>
      <!-- ----------------------------------------------報表列印順序---------------------------------------------- -->
      <!-- ----------------------------------------------報表顯示設定---------------------------------------------- -->
      <div class="mb-60">
        <div class="text-green mt-5 mb-20 font-20 rwd-mt">
          <strong>報表顯示設定</strong>
        </div>
        <div>1. 外幣保單明細，是否以原幣別顯示?</div>
        <div class="d-flex rwd-radio-block">
          <div class="radio radio-inline">
            <input type="radio" id="radioY" value="Y" v-model="isCurrency" />
            <label for="radioY">是</label>
          </div>
          <div class="radio radio-inline">
            <input type="radio" id="radioN" value="N" v-model="isCurrency" />
            <label for="radioN">否</label>
          </div>
        </div>
        <div class="mt-3">
          2. 逐月保費一覽表，是否顯示表定保費、年繳保費的合計?
        </div>
        <div class="d-flex rwd-radio-block">
          <div class="radio radio-inline">
            <input
              type="radio "
              id="radioPremiumY"
              value="Y"
              v-model="isTotalPremium"
            />
            <label for="radioPremiumY">是</label>
          </div>
          <div class="radio radio-inline">
            <input
              type="radio"
              id="radioPremiumN"
              value="N"
              v-model="isTotalPremium"
            />
            <label for="radioPremiumN">否</label>
          </div>
        </div>
        <div class="mt-3">
          3. 保戶為原住民時，是否顯示原住民姓名欄位顯示說明?
        </div>
        <div class="d-flex rwd-radio-block">
          <div class="radio radio-inline">
            <input
              type="radio"
              id="radioIndigenousY"
              value="Y"
              v-model="isIndigenous"
            />
            <label for="radioIndigenousY">是</label>
          </div>
          <div class="radio radio-inline">
            <input
              type="radio"
              id="radioIndigenousN"
              value="N"
              v-model="isIndigenous"
            />
            <label for="radioIndigenousN">否</label>
          </div>
        </div>
      </div>
      <!-- ----------------------------------------------報表顯示設定---------------------------------------------- -->
      <div class="text-black mb-30 font-24">
        <strong>步驟2/2:設定封面資訊</strong>
      </div>
      <!-- ----------------------------------------------封面樣式---------------------------------------------- -->
      <div>
        <div class="text-green mt-5 font-20 rwd-mt">
          <strong>封面樣式</strong>
        </div>
        <div class="d-flex justify-content-between col-8">
          <div style="width:15%">
            <div class="radio">
              <input
                type="radio"
                id="radioCoverC1"
                value="C1"
                v-model="isCover"
              />
              <label for="radioCoverC1">封面1</label>
            </div>
            <img
              style="width: 90%;"
              :src="`${BaseUrl}assets/MV_I00001_CoveragePage_C1.png`"
            />
          </div>
          <div style="width:15%">
            <div class="radio">
              <input
                type="radio"
                id="radioCoverC2"
                value="C2"
                v-model="isCover"
              />
              <label for="radioCoverC2">封面2</label>
            </div>
            <img
              style="width: 90%;"
              :src="`${BaseUrl}assets/MV_I00001_CoveragePage_C2.png`"
            />
          </div>
          <div style="width:15%">
            <div class="radio">
              <input
                type="radio"
                id="radioCoverC3"
                value="C3"
                v-model="isCover"
              />
              <label for="radioCoverC3">封面3</label>
            </div>
            <img
              style="width: 90%;"
              :src="`${BaseUrl}assets/MV_I00001_CoveragePage_C3.png`"
            />
          </div>
          <div style="width:15%">
            <div class="radio">
              <input
                type="radio"
                id="radioCoverC5"
                value="C5"
                v-model="isCover"
              />
              <label for="radioCoverC5">封面4</label>
            </div>
            <img
              style="width: 90%;"
              :src="`${BaseUrl}assets/MV_I00001_CoveragePage_C5.png`"
            />
          </div>
          <div style="width:15%">
            <div class="radio">
              <input
                type="radio"
                id="radioCoverC6"
                value="C6"
                v-model="isCover"
              />
              <label for="radioCoverC6">封面5</label>
            </div>
            <img
              style="width: 90%;"
              :src="`${BaseUrl}assets/MV_I00001_CoveragePage_C6.png`"
            />
          </div>
          <div style="width:15%">
            <div class="radio">
              <input
                type="radio"
                id="radioCoverC7"
                value="C7"
                v-model="isCover"
              />
              <label for="radioCoverC7">封面6</label>
            </div>
            <img
              style="width: 90%;"
              :src="`${BaseUrl}assets/MV_I00001_CoveragePage_C7.png`"
            />
          </div>
          <div style="width:15%">
            <div class="radio">
              <input type="radio" id="radioCoverN" value="N" v-model="isCover" />
              <label for="radioCoverN">不列印封面</label>
            </div>
          </div>
        </div>
      </div>
      <!-- ----------------------------------------------封面樣式---------------------------------------------- -->
      <!-- ----------------------------------------------謹致---------------------------------------------- -->
      <div class="text-green mt-5 font-20 mb-10 rwd-mt">
        <strong>謹致：</strong>
      </div>
      <form class="mb-30 row form">
        <div
          class="mb-10 mr-5 form"
          v-for="(user, index) in users"
          :key="index"
        >
          <div
            style="width: 169px; display: inline-block"
            :class="`checkboxMv pl-3 checkbox-inline mr-0 ${
              sincerely.users[index].checked ? 'activeInput' : 'nactiveInput'
            }`"
          >
            <input
              type="checkbox"
              :id="user.id"
              v-bind:value="user.id"
              v-model="sincerely.users[index].checked"
            />
            <label :for="user.id">
              <span>{{ truncate(user.name, 12) }}</span>
            </label>
          </div>

          <!-- <div class="ml-5p s6" v-if="sincerely.users[index].checked"> -->
          <div class="ml-2" style="display: inline-block">
            <select
              :disabled="!sincerely.users[index].checked"
              style="width: 97px"
              class="form-control"
              v-model="sincerely.users[index].role"
            >
              <option
                v-for="(role, roleIndex) in roles"
                v-bind:value="role.id"
                :key="roleIndex"
              >
                {{ role.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="mb-10 ml-10 w-243">
          <input
            class="form-control"
            alt="ch"
            placeholder="可自行輸入姓名"
            v-model="selfSincerely"
          />
        </div>
      </form>
      <!-- ----------------------------------------------謹致---------------------------------------------- -->
      <!-- ----------------------------------------------服務人員個人資訊---------------------------------------------- -->

      <div>
        <form class="form">
          <template v-if="!serverEdit">
            <div
              class="text-green font-20 d-flex align-items-center"
              style="margin-bottom: 12px"
            >
              <span class="custModifyAgent">服務人員資訊</span>
              <button
                type="button"
                style="vertical-align: middle"
                class="btn btn-default btn-sm"
                @click="clickEdit('edit')"
              >
                修改
              </button>
            </div>

            <div
              class="text-black mt-2 mb-3 ml-2 d-flex align-items-center"
              style="height: 40px"
            >
              <span class="custAgentTitle">保險顧問</span>
              <span class="ml-3 custAgentContent">{{
                agentData.agentNm ? agentData.agentNm : "--"
              }}</span>
            </div>
            <div
              class="text-black ml-2 d-flex"
              :class="{ 'section-loading': loading_1 }"
            >
              <span class="custAgentTitle" style="line-height: 40px"
                >手機&emsp;&emsp;</span
              >
              <span>
                <span class="ml-3 custAgentContent" style="line-height: 40px"
                  >{{
                    agentData.mobile ? agentData.mobile : " " | mobileFormat
                  }}
                </span>
                <div>&nbsp;</div>
              </span>
            </div>
          </template>
          <template v-else-if="serverEdit">
            <div
              class="text-green font-20 d-flex align-items-center"
              style="margin-bottom: 12px"
            >
              <span class="custModifyAgent">服務人員資訊</span>
              <button
                type="button"
                style="vertical-align: middle"
                class="btn btn-default btn-sm"
                @click="serverEdit = false"
              >
                取消
              </button>
              <button
                type="button"
                style="vertical-align: middle"
                class="btn btn-default btn-sm"
                @click="clickEdit('finish')"
              >
                完成
              </button>
              <span style="color: rgb(222, 64, 84)"
                >(修改完成後請務必點擊完成)</span
              >
            </div>
            <div
              class="text-black mt-2 mb-3 ml-2 d-flex align-items-center"
              style="height: 40px"
            >
              <span class="custAgentTitle">保險顧問</span>
              <span class="ml-3 custAgentContent">
                <input
                  type="text"
                  id="agentNm"
                  name="agentNm"
                  placeholder="姓名"
                  alt="ch"
                  class="form-control RectangleStyle RectangleWidth-m"
                  style="display: inline"
                  v-model="serverEditName"
                />
              </span>
            </div>
            <div
              class="text-black ml-2 d-flex"
              :class="{ 'section-loading': loading_1 }"
            >
              <span class="custAgentTitle" style="line-height: 40px"
                >手機&emsp;&emsp;</span
              >
              <span>
                <span class="ml-3 custAgentContent" style="line-height: 40px">
                  <input
                    type="text"
                    id="agentCellPhone"
                    name="agentCellPhone"
                    placeholder="手機"
                    v-validate="'cellphone'"
                    :class="{ 'is-invalid': errors.has('agentCellPhone') }"
                    class="form-control RectangleStyle RectangleWidth-m"
                    style="display: inline"
                    v-model="serverEditPhone"
                    maxlength="10"
                  />
                </span>
                <div>&nbsp;</div>
              </span>
            </div>
          </template>
        </form>
        <!--  <div style="text-align-last: left;" class="ml-2" :class="{ 'section-loading': loading_1 }">
          <div class="d-flex">
            <div class="text-black h5">
              <div class="custAgentTitle">保險顧問</div>
            </div>
            <div class="text-black h5">
              <span class="custAgentContent">{{ agentData.agentNm ? agentData.agentNm : "--" }}</span>
            </div>
          </div>
          <div class="d-flex">
            <div class="text-black h5">
              <div class="custAgentTitle">手機</div>
            </div>
            <div class="text-black h5">
              <span class="custAgentContent">{{
                agentData.mobile ? agentData.mobile : "--" | mobileFormat
              }}</span>
            </div>
          </div>
           <div class="d-flex" style="text-align-last: left;">
            <div class="text-black h5">
              <div class="custAgentTitle">公司電話</div>
            </div>
            <div class="text-black h5">
              <span class="custAgentContent">{{
                agentData.corp_phone ? agentData.corp_phone : ""
              }}</span>
            </div>
          </div>
           <div class="d-flex">
            <div class="text-black h5 custAgentTitle">Email
            </div>
            <div class="text-black h5 custAgentContent">{{ agentData.email ? agentData.email : "" }}
            </div>
          </div> 
          <div class="d-flex">
            <div class="text-black h5 custAgentTitle"> 公司地址
            </div>
            <span class="text-black h5 custAgentContent">{{ agentData.corp_addr ? agentData.corp_addr : "" }}
            </span>
          </div> 
        </div>-->
      </div>
      <!-- ----------------------------------------------服務人員資訊---------------------------------------------- -->
    </div>
    <!-- ----------------------------------------------列印PDF---------------------------------------------- -->

    <fixed-bottom v-show="!isScroll">
      <template slot="@function">
        <div>
          <form
            style="display: none"
            method="post"
            ref="form"
            target="_blank"
            :action="`${API_BASEURL}/servlet/HttpDispatcher/DOWNLOAD_FILE_API2/download?fileNo=${fileNo}`"
          >
            <input
              type="submit"
              formtarget="_blank"
              :value="`${API_BASEURL}/servlet/HttpDispatcher/DOWNLOAD_FILE_API2/download?fileNo=${fileNo}`"
            />
            <!-- <a @click="$refs.form.$el.submit()">{{`${API_BASEURL}/servlet/HttpDispatcher/DOWNLOAD_FILE_API2/download?fileNo=${fileNo}`}}</a> -->
          </form>
        </div>
        <div class="d-flex justify-content-end">
          <button
            class="btn btn-primary mr-0"
            v-show="!isIpad()"
            @click="showPDF(true)"
            type="button"
          >
            下載PDF
          </button>
          <button
            class="btn btn-primary mr-0"
            @click="showPDF(false)"
            type="button"
          >
            開啟PDF
          </button>
          <button
            :disabled="!$checkEdit(UserInfo)"
            type="button"
            class="btn btn-primary mr-0"
            @click="openEmail()"
          >
            發送EMAIL
          </button>
        </div>
      </template>
    </fixed-bottom>
    <!-- ----------------------------------------------列印pop-up---------------------------------------------- -->
    <mv-info :open="showOpenPdf" @close="printPDF()">
      <div class="text font-20" slot="content">
        <div style="color: red">
          <span style="font-weight: bold"
            >優化後新系統的保障數值更為精確，</span
          >
          建議您提供新的報表給客戶參考。
        </div>
      </div>
    </mv-info>
    <!-- ----------------------------------------------列印PDF---------------------------------------------- -->
    <!-- ----------------------------------------------發送email---------------------------------------------- -->
    <SendEmail-Modal
      :open="sendEmailModalOpen"
      @close="panelClose('sendEmailModalOpen')"
      @doSendEmail="doSendEmail"
    />

    <!-- 打開遮罩 -->
    <mv-mask :open="mvMaskOpen" />

    <mv-pdf-info
      :title="pdfModalTitle"
      :type="pdfModalType"
      :open="mvPdfInfoOpen"
      @close="panelClose('mvPdfInfoOpen')"
    >
      <!-- 1.契約內容一覽表 (完整版) -->
      <ol v-if="pdfModalType === '00'" slot="content">
        <li>以「被保人」角度彙整。</li>
        <li>
          列出該家戶成員持有保單完整資料
          <ul style="list-style-type: disc">
            <li>綠色底色：國泰保單</li>
            <li>藍色底色：同業保單</li>
            <li>紅色底色：建議書匯入</li>
          </ul>
        </li>
      </ol>
      <!-- 2.當年度保障總覽 (個人版) -->
      <ol v-else-if="pdfModalType === '18'" slot="content">
        <li>以「被保人」角度彙整。</li>
        <li>列出該被保人在十大保障分類中各給付項目之總金額。</li>
        <li>
          報表所呈現的給付項目、金額與「當年度保障總覽 (完整版-多張)」報表相同。
        </li>
        <li>
          欲確認各給付項目之金額明細，可參考「當年度保障明細
          (完整版-多張)」報表。
        </li>
      </ol>
      <!-- 3.當年度保障總覽 (完整版-多張) -->
      <ol v-else-if="pdfModalType === '02'" slot="content">
        <li>以「被保人」角度彙整。</li>
        <li>列出該家戶成員在十大保障分類中各給付項目之總金額。</li>
        <li>
          欲確認各給付項目之金額明細，可參考「當年度保障明細
          (完整版-多張)」報表。
        </li>
        <li>欲提供保戶全部給付項目，需搭配「其他保障明細 (搭配完整版)」。</li>
      </ol>
      <!-- 4.當年度保障明細 (完整版-多張) -->
      <ol v-else-if="pdfModalType === '03'" slot="content">
        <li>以「被保人」角度彙整。</li>
        <li>
          列出該被保人的各張保單在十大保障分類中各給付項目之金額。
          <ul style="list-style-type: disc">
            <li>綠色底色：國泰保單</li>
            <li>藍色底色：同業保單</li>
            <li>紅色底色：建議書匯入</li>
          </ul>
        </li>
        <li>欲提供保戶全部給付項目，需搭配「其他保障明細 (搭配完整版)」。</li>
      </ol>
      <!-- 5.其他保障明細 (搭配完整版) -->
      <ol v-else-if="pdfModalType === '15'" slot="content">
        <li>以「該家戶成員持有的各張保單」角度彙整。</li>
        <li>
          列出該家戶成員的各張保單暫無納入完整版報表中的各項給付項目與金額。
          <ul style="list-style-type: disc">
            <li>綠色底色：國泰保單</li>
            <li>藍色底色：同業保單</li>
            <li>紅色底色：建議書匯入</li>
          </ul>
        </li>
        <li>
          欲提供保戶全部給付項目，需搭配「當年度保障總覽
          (完整版-多張)」或「當年度保障明細 (完整版-多張)」
        </li>
      </ol>
      <!-- 6.契約內容一覽表 (精簡版) -->
      <ol v-else-if="pdfModalType === '01'" slot="content">
        <li>以「被保人」角度彙整。</li>
        <li>
          列出該家戶成員持有保單基本資料
          <ul style="list-style-type: disc">
            <li>綠色底色：國泰保單</li>
            <li>藍色底色：同業保單</li>
            <li>紅色底色：建議書匯入</li>
          </ul>
        </li>
      </ol>
      <!-- 7.當年度保障總覽 (精簡版-一張) -->
      <ol v-else-if="pdfModalType === '04'" slot="content">
        <li>以「被保人」角度彙整。</li>
        <li>單頁列出該家戶成員在十大保障分類中各項重點給付項目之總金額。</li>
        <li>
          欲確認各給付項目之金額明細，可參考「當年度保障明細
          (精簡版-一張)」報表。
        </li>
        <li>欲提供保戶全部給付項目，需搭配「其他保障明細 (搭配精簡版)」。</li>
      </ol>
      <!-- 8.當年度保障明細 (精簡版-一張) -->
      <ol v-else-if="pdfModalType === '05'" slot="content">
        <li>以「被保人持有的各張保單」角度彙整。</li>
        <li>
          單頁列出該被保人的各張保單在十大保障分類中各項重點給付項目之金額。
          <ul style="list-style-type: disc">
            <li>綠色底色：國泰保單</li>
            <li>藍色底色：同業保單</li>
            <li>紅色底色：建議書匯入</li>
          </ul>
        </li>
        <li>欲提供保戶全部給付項目，需搭配「其他保障明細 (搭配精簡版)」。</li>
      </ol>
      <!-- 9.其他保障明細 (搭配精簡版) -->
      <ol v-else-if="pdfModalType === '17'" slot="content">
        <li>以「該家戶成員持有的各張保單」角度彙整。</li>
        <li>
          列出該家戶成員的各張保單暫無納入精簡版明細報表中的各項給付項目與金額。
          <ul style="list-style-type: disc">
            <li>綠色底色：國泰保單</li>
            <li>藍色底色：同業保單</li>
            <li>紅色底色：建議書匯入</li>
          </ul>
        </li>
        <li>
          欲提供保戶全部給付項目，需搭配「當年度保障總覽
          (精簡版-一張)」或「當年度保障明細 (精簡版-一張)
        </li>
      </ol>
      <!-- 10.逐月保費一覽表 -->
      <ol v-else-if="pdfModalType === '06'" slot="content">
        <li>以「該家戶成員持有的各張保單」角度彙整。</li>
        <li>
          列出該家戶成員的各張保單未來一年各月份應繳保費。
          <ul style="list-style-type: disc">
            <li>綠色底色：國泰保單</li>
            <li>藍色底色：同業保單</li>
            <li>紅色底色：建議書匯入</li>
          </ul>
        </li>
      </ol>
      <!-- 11.逐年保費預估表總覽 -->
      <ol v-else-if="pdfModalType === '07'" slot="content">
        <li>以「被保人」角度彙整。</li>
        <li>單頁列出該家戶成員未來30年逐年應繳保費總金額。</li>
      </ol>
      <!-- 12.逐年保費預估表明細 -->
      <ol v-else-if="pdfModalType === '08'" slot="content">
        <li>以「被保人」角度彙整。</li>
        <li>
          單頁列出該被保人的各張保單在未來30年逐年應繳保費總金額。
          <ul style="list-style-type: disc">
            <li>綠色底色：國泰保單</li>
            <li>藍色底色：同業保單</li>
            <li>紅色底色：建議書匯入</li>
          </ul>
        </li>
      </ol>
      <!-- 13.身故/完全失能保障總覽 -->
      <ol v-else-if="pdfModalType === '09'" slot="content">
        <li>以「被保人」角度彙整。</li>
        <li>單頁列出該家戶成員在未來30年逐年身故給付總金額。</li>
      </ol>
      <!-- 14.身故/完全失能保障明細 -->
      <ol v-else-if="pdfModalType === '10'" slot="content">
        <li>以「被保人」角度彙整。</li>
        <li>
          單頁列出該被保人的各張保單在未來30年逐年身故給付總金額。
          <ul style="list-style-type: disc">
            <li>綠色底色：國泰保單</li>
            <li>藍色底色：同業保單</li>
            <li>紅色底色：建議書匯入</li>
          </ul>
        </li>
      </ol>
      <!-- 15.基本醫療保障期間 -->
      <ol v-else-if="pdfModalType === '11'" slot="content">
        <li>以「被保人」角度彙整。</li>
        <li>
          列出該被保人的各張保單以下四項醫療給付項目金額、保障期間資訊
          <ul style="list-style-type: disc">
            <li>意外醫療：住院日額保險金</li>
            <li>疾病醫療：住院日額保險金</li>
            <li>手術醫療：住院手術保險金</li>
            <li>實支實付：傷害醫療限額</li>
          </ul>
        </li>
      </ol>
      <!-- 16.滿期金或年金領回總覽 -->
      <ol v-else-if="pdfModalType === '12'" slot="content">
        <li>以「被保人」角度彙整。</li>
        <li>單頁列出該家戶成員在未來30年逐年滿期金或年金領回總金額。</li>
      </ol>
      <!-- 17.滿期金或年金領回明細 -->
      <ol v-else-if="pdfModalType === '13'" slot="content">
        <li>以「被保人」角度彙整。</li>
        <li>
          單頁列出該被保人的各張保單在未來30年逐年滿期金或年金總金額。
          <ul style="list-style-type: disc">
            <li>綠色底色：國泰保單</li>
            <li>藍色底色：同業保單</li>
            <li>紅色底色：建議書匯入</li>
          </ul>
        </li>
      </ol>
      <!-- 18.團險保障明細表 -->
      <ol v-else-if="pdfModalType === '16'" slot="content">
        <li>以「被保人」角度彙整。</li>
        <li>列出該家戶成員的各張團險保單之各項給付項目及金額</li>
      </ol>
      <!-- 19.其他保障明細 (搭配完整版) -->
      <ol v-else-if="pdfModalType === '14'" slot="content">
        <li>以「被保人」角度彙整。</li>
        <li>列出該家戶成員的各張投資型保單之投資概況</li>
      </ol>
    </mv-pdf-info>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import moment from "moment";
import Avatar from "@/desktop/components/Avatar";
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import { pdfPrintMixin } from "@/desktop/views/mv/pdfPrint/pdfPrintMixin";
import WarningModal from "@/desktop/components/WarningModal";
import NewGroup from "@/desktop/components/NewGroup";
import AddGroupModal from "@/desktop/components/AddGroupModal";
import SendEmailModal from "@/desktop/views/mv/components/SendEmailModal";
import EditAgentInfoFamilyModal from "@/desktop/views/mv/components/EditAgentInfoFamilyModal";
import FixedBottom from "@/desktop/views/mv/components/modal/fixedBotton";
import mvInfo from "@/desktop/views/mv/components/mvInfo";
//loading isMask
import mvMask from "@/desktop/views/mv/components/mvMask";
import mvPdfInfo from "@/desktop/views/mv/components/mvPdfInfo";
import HardwordMixins from "@/mixins/Hardword";
import {
  getAllFamily,
  getAgntInfo,
  getFamilyCheckPDFFile,
  getFamilyCheckPDFFileForMail,
  getFamilyCheckPDFFileByFileNo,
  getPdfFileForReport,
  getCommonlyUsedReport,
  insertCommonlyUsedReport,
  deleteCommonlyUsedReport,
  getServiceCenterData,
} from "@/service";
import { Validator } from "vee-validate";
import { mapGetters } from "vuex";
import { log } from "util";

Validator.extend("cellphone", {
  getMessage: `手機格式有誤`,
  validate: (value) => {
    if (value == "") {
      return true;
    }
    let mobilePattern = new RegExp("^[0-9]{10}$");
    return mobilePattern.test(value);
  },
});
export default {
  name: "PolicyHealthCheckPDF",
  mixins: [commonMixin, HardwordMixins, pdfPrintMixin],
  data() {
    return {
      //getAllCurrentYearCoverageReportInfo
      pdfData: this.$store.state.PDFData,
      dragging: false,
      enabled: true,
      //是否滾動
      isScroll: false,
      //全選
      theadAll: false,
      //業務員ID
      // agidno: this.$store.state.userInfo.id,
      agidno: this.$store.state.userInfo.id,
      //業務員名字
      agentName: this.$store.state.userInfo.name,
      //過濾有勾選
      familyResultFilter: [],
      //全部報表
      familyInfoList: [],
      //全部報表Drag
      familyInfoListDrag: [],
      //推薦報表
      recommendReports: [], // "00", "18", "03", "15"
      //是否為原住民
      isIndigenous: "N",
      //是否列印封面
      isCover: "N",
      //外幣
      isCurrency: "Y",
      //逐一保費一覽表，是否顯示表定保費、年繳保費的合計?
      isTotalPremium: "Y",
      //謹致
      sincerely: { users: [{ checked: false, id: 0, name: "", role: 0 }] },
      serviceCenterData: {
        insuredonly: "",
        holderbirth: "",
        proposeronly: "",
        holderid: "",
        holderName: "",
        agentid: "",
        agentName: "",
        membersinfo: [{}],
      },
      serverEdit: false,
      serverEditName: "",
      serverEditPhone: "",
      remoteDataMessage: "資料讀取中，請稍候...",
      users: [],
      roles: [
        {
          id: 0,
          name: "請選擇",
        },
        {
          id: 1,
          name: "先生",
        },
        {
          id: 2,
          name: "小姐",
        },
        {
          id: 3,
          name: "女士",
        },
        {
          id: 4,
          name: "保戶",
        },
        {
          id: 5,
          name: "小朋友",
        },
        {
          id: 6,
          name: "老師",
        },
        {
          id: 7,
          name: "教授",
        },
        {
          id: 8,
          name: "醫生",
        },
      ],
      sendEmailModalOpen: false,
      mvMaskOpen: false,
      agentData: {
        agentNm: "",
        mobile: "",
        agentNm2: "",
        mobile2: "",
        corp_phone: "",
        email: "",
        corp_addr: "",
      },
      loading_1: false,
      //自行輸入姓名
      selfSincerely: "",
      //控制外層選取報表
      isSelectPdf: false,
      //報表說明開關
      mvPdfInfoOpen: false,
      //報表說明標題
      pdfModalTitle: "",
      //報表說明種類
      pdfModalType: "",
      //要跳focus的位置
      focusPosition: "",
      //PDF 彈窗
      showOpenPdf: false,
      isDownload: false,
      //PDF過多警示
      policyOverWarn: localStorage.policyOverWarn === "true" ? true : false,
      fileNo: "",
      API_BASEURL: "",
    };
  },
  components: {
    draggable,
    Avatar,
    SendEmailModal,
    EditAgentInfoFamilyModal,
    mvMask,
    FixedBottom,
    mvPdfInfo,
    mvInfo,
  },
  computed: {
    ...mapGetters(["BaseUrl", "UserInfo"]),
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    is_iPad() {
      if (/iPad|iPhone|iPod/.test(navigator.platform)) {
        return true;
      } else {
        // 部分 iPadPro 會顯示為 MacIntel
        return (
          navigator.maxTouchPoints &&
          navigator.maxTouchPoints > 2 &&
          /MacIntel/.test(navigator.platform)
        );
      }
    },
    isTablet() {
      const ua = navigator.userAgent;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return true;
      } else if (this.is_iPad) {
        return true;
      }
      return false;
    },
  },
  watch: {
    familyInfoList: {
      deep: true,
      handler(newValue, oldValue) {
        let selectCheck = 0;
        for (let i = 0; i < this.familyInfoList.length; i++) {
          let chk = 0;
          let isAll = this.familyInfoList[i].isAll;
          for (
            let j = 0;
            j < this.familyInfoList[i].familyResultFilter.length;
            j++
          ) {
            if (this.familyInfoList[i].familyResultFilter[j].check == true) {
              chk++;
              selectCheck++;
            }
          }
          if (chk == this.familyInfoList[i].familyResultFilter.length) {
            this.familyInfoList[i].theadAll = true;
            this.familyInfoList[i].theadAllS = true;
          } else if (chk === 0) {
            if (this.familyInfoList[i].familyResultFilter.length == 1) {
              // this.familyInfoList[i].theadAll = false;
            }
            this.familyInfoList[i].theadAllS = false;
          } else {
            this.familyInfoList[i].theadAllS = true;
          }
          if (
            (chk > 0 || isAll) &&
            !this.familyInfoListDragInclude(this.familyInfoList[i].reportTitle)
          ) {
            this.familyInfoListDrag.push(this.familyInfoList[i]);
            //整理
            // this.sortDragItem();
          } else if (
            chk == 0 &&
            this.familyInfoListDragInclude(this.familyInfoList[i].reportTitle)
          ) {
            this.familyInfoListDragInclude(
              this.familyInfoList[i].reportTitle,
              "Y"
            );
            //整理
            // this.sortDragItem();
          }
        }
        if (selectCheck > 0) {
          this.isSelectPdf = true;
        } else {
          this.isSelectPdf = false;
        }
      },
    },
  },
  methods: {
    ...mapActions([
      "updateUserItems",
      "setPageLock",
      "updateFamilyResultFilter",
      "updateUserInfo",
    ]),
    moment,
    instructions() {
      this.panelOpen("mvMaskOpen");
      let sendData = this.getSendData();
      sendData.isSendMail = false;
      // 若為webview開啟則不開新視窗
      let newWindow = this.isWebView() ? window : this.openNewWindow();
      getPdfFileForReport(this.agidno, "family.pdf").then((result) => {
        if (result.byteLength <= 120) {
          if (!this.isWebView()) {
            newWindow.close();
          }
          this.panelClose("mvMaskOpen");
          setTimeout(() => alert("報表查無資料"));
          return;
        }
        let file = new Blob([result], { type: "application/pdf" });
        this.sendPdfDataToApp(file, "家庭保單健檢規劃書-使用說明");
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(
            file,
            "家庭保單健檢規劃書-使用說明.pdf"
          );
        } else {
          newWindow.location = URL.createObjectURL(file);
        }
        this.panelClose("mvMaskOpen");
      });
    },
    openPdfInfo(title, type) {
      this.pdfModalTitle = title;
      this.pdfModalType = type;
      this.panelOpen("mvPdfInfoOpen");
    },
    getAgentEmail() {
      this.loading_1 = true;
      getAgntInfo(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.id
      ).then((result) => {
        if (result.header && result.header.status === "200") {
          this.agentData.agentNm = result.data.agnt_name;
          if (this.agentData.agentNm == null) {
            //資料庫無資料
            this.loading_1 = false;
            return;
          }

          this.agentData.mobile = result.data.mobile;
          this.agentData.corp_phone =
            result.data.corp_tel_area + "-" + result.data.corp_tel;
          this.agentData.email = result.data.email;
          this.agentData.corp_addr =
            result.data.corp_addr1 +
            result.data.corp_addr2 +
            result.data.corp_addr3;
        }
        this.loading_1 = false;
      });
    },
    len(str) {
      return str.replace(/[^\x00-\xff]/g, "xx").length;
    },
    sub(str, n) {
      let l = 0;
      for (let i = 0; i < str.length; i++) {
        if (str[i].match(/[^\x00-\xff]/g)) {
          l += 2;
        } else {
          l++;
        }
        if (l >= n) {
          return str.substr(0, i + 1);
        }
      }
    },
    truncate(str, n) {
      if (str) {
        return this.len(str) > n ? this.sub(str, n) + "..." : str;
      } else {
        return "";
      }
    },
    selectAll(selectType) {
      this.familyInfoList.forEach((element) => {
        element.theadAll = selectType;
        element.familyResultFilter.forEach(
          (elementI) => (elementI.check = selectType)
        );
      });
    },
    selectCommonlyUsed() {
      this.familyInfoList.forEach((element) => {
        if (element.commonlyUsed) {
          element.theadAll = true;
          element.familyResultFilter.forEach(
            (elementI) => (elementI.check = true)
          );
        }
      });
    },
    selectRecommend() {
      this.familyInfoList.forEach((element) => {
        if (this.recommendReports.includes(element.reportType)) {
          element.theadAll = true;
          element.familyResultFilter.forEach(
            (elementI) => (elementI.check = true)
          );
        }
      });
    },
    showPDF(isDownload) {
      let chkNoPDFPrint = false;
      let filterType = ["14", "16"];
      let printcheck = true;
      this.isDownload = isDownload;
      for (let i = 0; i < this.familyInfoList.length; i++) {
        let theadAll = this.familyInfoList[i].theadAll;
        let reportType = this.familyInfoList[i].reportType;
        if (theadAll) {
          chkNoPDFPrint = true;
          if (!filterType.includes(reportType)) {
            printcheck = false;
          }
        }
      }
      if (!chkNoPDFPrint) {
        this.$toast.info({ title: "請先勾選報表" });
        return false;
      }
      if (!this.checkPDF()) return;

      this.printPDF();
    },
    checkPDF() {
      let chkAll = false;
      let chkPosition = false;
      for (let i = 0; i < this.familyInfoList.length; i++) {
        let theadAll = this.familyInfoList[i].theadAll;
        let chkPrint = 0;
        this.familyInfoList[i].familyResultFilter.forEach((item) => {
          if (theadAll && !item.check) {
            chkPrint++;
          }
        });
        if (chkPrint == this.familyInfoList[i].familyResultFilter.length) {
          this.familyInfoList[i].familyResultFilter = this.familyInfoList[
            i
          ].familyResultFilter.map((item) => {
            item.chkFocus = true;
            if (!chkPosition) {
              this.focusPosition = i;
              chkPosition = true;
            }
            chkAll = true;
            return item;
          });
        } else {
          this.familyInfoList[i].familyResultFilter.forEach((item) => {
            item.chkFocus = false;
          });
        }
      }
      if (
        this.focusPosition != null &&
        Number.isInteger(this.focusPosition) &&
        chkAll
      ) {
        const { $ } = window;
        const ref = `customer${this.focusPosition}-0`;

        let $ref = null;
        if (Array.isArray(this.$refs[ref])) {
          $ref = $(this.$refs[ref][0]);
        } else {
          $ref = $(this.$refs[ref]);
        }
        $("html, body").scrollTop($ref.offset().top - 300);

        this.$toast.info({ title: "請確認列印對象" });
        if (this.showOpenPdf) {
          this.panelClose("showOpenPdf");
        }
        return false;
      }
      if (this.showOpenPdf) {
        this.panelClose("showOpenPdf");
      }
      return true;
    },
    printPDF() {
      this.panelOpen("mvMaskOpen");
      let sendData = this.getSendData();
      sendData.isSendMail = false;
      // 若為webview開啟則不開新視窗
      let newWindow = this.isWebView() ? window : this.openNewWindow();
      getFamilyCheckPDFFile(this.agidno, sendData).then((result) => {
        let fileName =
          this.$store.state.userItems["name"] + "(家庭)" + result.fileName;

        // if (!(result.file && result.file.length > 0)) {
        //   if (!this.isWebView()) {
        //     newWindow.close();
        //   }
        //   this.panelClose("mvMaskOpen");
        //   setTimeout(() => alert("報表查無資料"));
        //   return;
        // }
        if (!result.fileNo) {
          this.panelClose("mvMaskOpen");
          setTimeout(() => alert("報表查無資料"));
          return;
        } else {
          this.fileNo = result.fileNo;
          setTimeout(() => {
            let file = new Blob([new Uint8Array(result.file)], {
              type: "application/pdf",
            });
            this.sendPdfDataToApp(file, fileName);
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(file, fileName);
            } else {
              if (this.isDownload) {
                this.chromeDonloadFile(file, fileName, newWindow);
              } else {
                if (this.isWebView()) {
                  newWindow.location = URL.createObjectURL(file);
                } else {
                  newWindow.location = `${this.API_BASEURL}/servlet/HttpDispatcher/DOWNLOAD_FILE_API2/download?fileNo=${this.fileNo}`;
                  // window.open(`${this.API_BASEURL}/servlet/HttpDispatcher/DOWNLOAD_FILE_API2/download?fileNo=${this.fileNo}`, '_blank')
                }
              }
            }
            this.panelClose("mvMaskOpen");
          }, 1000);
          // getFamilyCheckPDFFileByFileNo(this.agidno,result.fileNo).then((resultPdf) => {
          //     let file = new Blob([resultPdf], { type: "application/pdf" });
          //     this.sendPdfDataToApp(file, fileName);
          //     if (window.navigator.msSaveOrOpenBlob) {
          //       window.navigator.msSaveOrOpenBlob(file, fileName);
          //     } else {
          //       if (this.isDownload) {
          //         this.chromeDonloadFile(file, fileName, newWindow);
          //       } else {
          //         newWindow.location = URL.createObjectURL(file);
          //       }
          //     }
          //     this.panelClose("mvMaskOpen");
          // })
        }
      });
      if (this.showOpenPdf) {
        this.panelClose("showOpenPdf");
      }
    },
    openEmail() {
      let chkNoPDFPrint = false;
      for (let i = 0; i < this.familyInfoList.length; i++) {
        let theadAll = this.familyInfoList[i].theadAll;
        if (theadAll) {
          chkNoPDFPrint = true;
        }
      }
      if (!chkNoPDFPrint) {
        this.$toast.info({ title: "請先勾選報表" });
        return false;
      }
      if (!this.checkPDF()) return;
      this.panelOpen("sendEmailModalOpen");
    },
    doSendEmail(form) {
      if (!this.checkPDF()) return;
      this.panelOpen("mvMaskOpen");
      let sendData = this.getSendData();
      sendData.subject = form.subject;
      sendData.senderName = form.senderName;
      sendData.sender = form.sender + "@cathaylife.com.tw";
      sendData.receiver = form.receiver;
      sendData.receivercc = form.receivercc;
      sendData.receiverbcc = form.receiverbcc;
      sendData.isSendMail = true;

      getFamilyCheckPDFFileForMail(this.agidno, sendData).then((result) => {
        if (result.header && result.header.status === "200") {
          this.$toast.info({ title: "發送成功" });
        } else {
          this.$toast.info({ title: "發送失敗" });
        }
        this.panelClose("mvMaskOpen");
      });
    },
    getSendData() {
      let familyInfoList = [];
      let cslist = [];
      let cslistName = [];
      console.log('this.serviceCenterData >> ',this.serviceCenterData)
      this.serviceCenterData.membersinfo.map((e) => {
        cslistName.push(e.memberName);
        cslist.push(e.memberid);
      });

      this.familyInfoListDrag.forEach((dragItems) => {
        let familyInfoListObj = {};
        let familyInfoListObj141 = {};

        familyInfoListObj["reportType"] = dragItems.reportType;
        familyInfoListObj["cslist"] = cslist;
        familyInfoListObj["cslistName"] = cslistName;
        if (dragItems.reportType == "14") {
          familyInfoListObj141["reportType"] = "141";
          familyInfoListObj141["cslist"] = cslist;
          familyInfoListObj141["cslistName"] = cslistName;
        }

        familyInfoList.push(familyInfoListObj);
        if (dragItems.reportType == "14") {
          familyInfoList.push(familyInfoListObj141);
        }
      });

      // familyInfoList["agidno"] = this.agidno;
      // familyInfoList["familyid"] = this.$store.state.userItems.csidno;
      // familyInfoList["isIndigenous"] = this.isIndigenous;
      // familyInfoList["agentInfo"] = [
      //   {
      //     AGENTINFONAME: "AGENT01",
      //     AGENTINFOMOBILE: "0912345678",
      //     REPORTSERIALNUMBER: `${this.generateSerial()}-${this.generateSerial()}`,
      //     AGIDNO: this.agidno
      //   }
      // ];
      let cslistAll = cslist;
      let cslistAllName = cslistName;
      if (this.isCover != "N") {
        familyInfoList.unshift({
          reportType: this.isCover,
          cslist: cslistAll,
          cslistName: cslistAllName,
        });
      }
      let sincerely = "";
      this.sincerely.users.map((map) => {
        if (map.checked) {
          let roleName;
          this.roles.map((item) => {
            if (item.id === map.role) {
              if (map.role == 0) {
                roleName = "";
              } else {
                roleName = item.name;
              }
            }
          });
          sincerely += map.name + roleName + ",";
        }
      });
      sincerely = sincerely.slice(0, sincerely.length - 1);
      let sendData = {
        cslistAll: cslistAll,
        familyInfoList: familyInfoList,
        agidno: this.serviceCenterData.agentid,
        familyid: null,
        familyName: null,
        isIndigenous: this.isIndigenous,
        isTotalPremium: this.isTotalPremium,
        isCurrency: this.isCurrency,
        sincerely:
          sincerely +
          (sincerely.length > 0 && this.selfSincerely != ""
            ? `,${this.selfSincerely}`
            : this.selfSincerely),
        agentInfo: [
          {
            AGENTINFONAME: this.agentData.agentNm,
            AGENTINFONAME2: null,
            AGENTINFOMOBILE: null,
            AGENTINFOMOBILE2: null,
            REPORTSERIALNUMBER: `${this.generateSerial()}-${this.generateSerial()}`,
            AGIDNO: this.serviceCenterData.agentid,
          },
        ],
        isServiceCenter: "Y",
        membersinfo: this.serviceCenterData.membersinfo,
        pdfData: this.pdfData,
        holderid:this.serviceCenterData.holderid
      };

      return sendData;
    },
    sortDragItem() {
      let result = [];
      const reportTypeList = [
        "00",
        "18",
        "02",
        "03",
        "15",
        "01",
        "04",
        "05",
        "17",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "16",
      ];
      if (this.familyInfoListDrag.length > 0) {
        reportTypeList.forEach((type) => {
          for (let i = 0; i < this.familyInfoListDrag.length; i++) {
            if (this.familyInfoListDrag[i].reportType == type) {
              result.push(this.familyInfoListDrag[i]);
              break;
            }
          }
        });
        this.familyInfoListDrag = result;
      }
    },
    familyInfoListDragInclude(title, isSplice) {
      for (let i = 0; i < this.familyInfoListDrag.length; i++) {
        if (this.familyInfoListDrag[i].reportTitle == title) {
          if (isSplice === "Y") {
            this.familyInfoListDrag.splice(i, 1);
          }
          return true;
        }
      }
      return false;
    },
    checkMove: function (e) {
      // console.log("Future index: " + e.draggedContext.futureIndex);
    },
    detectIEEdge() {
      var ua = window.navigator.userAgent;

      var msie = ua.indexOf("MSIE ");
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
      }

      var trident = ua.indexOf("Trident/");
      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf("rv:");
        return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
      }

      var edge = ua.indexOf("Edge/");
      if (edge > 0) {
        // Edge => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
      }

      // other browser
      return false;
    },
    changeInput(item) {
      if (this.detectIEEdge() === 11) {
        item.familyResultFilter.forEach(
          (element) => (element.check = item.theadAll)
        );
      } else {
        item.familyResultFilter.forEach(
          (element) => (element.check = !item.theadAll)
        );
      }
    },
    changeInputTF(item, type) {
      if (this.detectIEEdge() === 11) {
        item.familyResultFilter.forEach((element) => (element.check = type));
        if (
          item.familyResultFilter.filter(function (value) {
            return value.check === true;
          }).length == 0
        ) {
          //20220210 調整為不因為成員全無勾選而收闔
          // item.theadAll = false;
        }
      } else {
        item.familyResultFilter.forEach((element) => (element.check = type));
        if (
          item.familyResultFilter.filter(function (value) {
            return value.check === true;
          }).length == 0
        ) {
          //20220210 調整為不因為成員全無勾選而收闔
          // item.theadAll = false;
        }
      }
    },
    checkNonSelected(item, indexI) {
      //20220210 調整為不因為成員全無勾選而收闔
      // item.familyResultFilter[indexI].check =
      //   !item.familyResultFilter[indexI].check;
      // if (
      //   item.familyResultFilter.filter(function (value) {
      //     return value.check === true;
      //   }).length == 0
      // ) {
      //   item.theadAll = false;
      // }
    },
    setCommonlyUsed(item) {
      let report = "00"; // 00：家庭保單健檢規劃書 01：尋保圖（個人總覽）02：321+1保藏圖
      if (item.commonlyUsed) {
        deleteCommonlyUsedReport(this.agidno, report, item.reportType).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              item.commonlyUsed = false;
              this.sortCommonlyUsed();
            }
          }
        );
      } else {
        const reportLimit = 10;
        if (
          this.familyInfoList.filter((item) => {
            return item.commonlyUsed == true;
          }).length >= reportLimit
        ) {
          this.$toast.info({
            title: `標記「常用報表」上限為${reportLimit}張報表`,
          });
        } else {
          insertCommonlyUsedReport(this.agidno, report, item.reportType).then(
            (result) => {
              if (result.header && result.header.status == "200") {
                item.commonlyUsed = true;
                this.sortCommonlyUsed();
              }
            }
          );
        }
      }
    },
    formatDate(preDate) {
      if (preDate) {
        let dd = moment(preDate).format("YYYY-MM-DD").split("-");
        dd[0] = dd[0] - 1911;
        dd = dd.join("/");

        return dd;
      } else {
        return "";
      }
    },
    generateSerial() {
      var chars =
          "1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
        serialLength = 10,
        randomSerial = "",
        i,
        randomNumber;

      for (i = 0; i < serialLength; i = i + 1) {
        randomNumber = Math.floor(Math.random() * chars.length);
        randomSerial += chars.substring(randomNumber, randomNumber + 1);
      }
      return randomSerial;
    },
    setReportFamilyInfoList(filter, i, reportType) {
      this.$set(this.familyInfoList, i, {
        isAll: false,
        familyResultFilter: filter,
        reportType: reportType,
        reportTitle: this.changeReportTitle(reportType),
      });
    },
    setAgentData(agentDataFromPop) {
      this.agentData.agentNm = this.parseNull(agentDataFromPop.agentNm);
      this.agentData.mobile = this.parseNull(agentDataFromPop.agentCellPhone);
      this.agentData.corp_phone = this.parseNull(agentDataFromPop.agentEmail);
      this.agentData.email = this.parseNull(
        agentDataFromPop.office_phone[0] +
          "-" +
          agentDataFromPop.office_phone[1]
      );
      this.agentData.corp_addr = this.parseNull(
        agentDataFromPop.office_address[1] +
          agentDataFromPop.office_address[2] +
          agentDataFromPop.office_address[3]
      );
      this.loading_1 = false;
    },
    parseNull(check) {
      return check ? check : "";
    },
    init() {
      //打開可拖曳
      document.ondragstart = function () {
        return true;
      };
      for (let i = 0; i < 22; i++) {
        let filter = [];
        filter.push({
          csidno: "serviceCenter",
          name: "serviceCenter",
          check: false,
        });
        if (this.$checkMaintence(this.Userinfo)) {
          switch (i) {
            case 0:
              this.setReportFamilyInfoList(filter, i, "00");
              break;
            case 1:
              this.setReportFamilyInfoList(filter, i, "18");
              break;
            case 2:
              this.setReportFamilyInfoList(filter, i, "02");
              break;
            case 3:
              this.setReportFamilyInfoList(filter, i, "03");
              break;
            case 4:
              this.setReportFamilyInfoList(filter, i, "15");
              break;
            case 5:
              this.setReportFamilyInfoList(filter, i, "01");
              break;
            case 6:
              this.setReportFamilyInfoList(filter, i, "04");
              break;
            case 7:
              this.setReportFamilyInfoList(filter, i, "05");
              break;
            case 8:
              this.setReportFamilyInfoList(filter, i, "17");
              break;
            case 9:
              this.setReportFamilyInfoList(filter, i, "06");
              break;
            case 10:
              this.setReportFamilyInfoList(filter, i, "07");
              break;
            case 11:
              this.setReportFamilyInfoList(filter, i, "08");
              break;
            case 12:
              this.setReportFamilyInfoList(filter, i, "09");
              break;
            case 13:
              this.setReportFamilyInfoList(filter, i, "10");
              break;
            case 14:
              this.setReportFamilyInfoList(filter, i, "11");
              break;
            case 15:
              this.setReportFamilyInfoList(filter, i, "12");
              break;
            case 16:
              this.setReportFamilyInfoList(filter, i, "13");
              break;
            case 17:
              this.setReportFamilyInfoList(filter, i, "14");
              break;
            case 18:
              this.setReportFamilyInfoList(filter, i, "16");
              break;
            case 19:
              this.setReportFamilyInfoList(filter, i, "20");
              break;
            case 20:
              this.setReportFamilyInfoList(filter, i, "19");
              break;
            case 21:
              this.setReportFamilyInfoList(filter, i, "21");
              break;
          }
        } else {
          switch (i) {
            case 0:
              this.setReportFamilyInfoList(filter, i, "00");
              break;
            case 1:
              this.setReportFamilyInfoList(filter, i, "18");
              break;
            case 2:
              this.setReportFamilyInfoList(filter, i, "02");
              break;
            case 3:
              this.setReportFamilyInfoList(filter, i, "03");
              break;
            case 4:
              this.setReportFamilyInfoList(filter, i, "15");
              break;
            case 5:
              this.setReportFamilyInfoList(filter, i, "01");
              break;
            case 6:
              this.setReportFamilyInfoList(filter, i, "04");
              break;
            case 7:
              this.setReportFamilyInfoList(filter, i, "05");
              break;
            case 8:
              this.setReportFamilyInfoList(filter, i, "17");
              break;
            case 9:
              this.setReportFamilyInfoList(filter, i, "06");
              break;
            case 10:
              this.setReportFamilyInfoList(filter, i, "07");
              break;
            case 11:
              this.setReportFamilyInfoList(filter, i, "08");
              break;
            case 12:
              this.setReportFamilyInfoList(filter, i, "09");
              break;
            case 13:
              this.setReportFamilyInfoList(filter, i, "10");
              break;
            case 14:
              this.setReportFamilyInfoList(filter, i, "11");
              break;
            case 15:
              this.setReportFamilyInfoList(filter, i, "12");
              break;
            case 16:
              this.setReportFamilyInfoList(filter, i, "13");
              break;
            case 17:
              this.setReportFamilyInfoList(filter, i, "14");
              break;
            case 18:
              this.setReportFamilyInfoList(filter, i, "16");
              break;
          }
        }
      }
      let titleChange = [
        "契約內容一覽表(完整版)",
        "當年度保障總覽(個人版)",
        "當年度保障總覽(完整版-多張)",
        "逐月保費一覽表",
        "身故/完全失能 逐年保障明細表",
        "基本醫療保障期間表",
        "滿期金或年金領回總覽",
        "滿期金或年金領回明細表",
      ];
      this.familyInfoList = this.familyInfoList.map((e) => {
        if (titleChange.includes(e.reportTitle)) {
          e.reportTitle = e.reportTitle + "-客服列印";
        }
        return e;
      });

      this.remoteDataMessage =
        "無任何家戶(請先將客戶完成歸戶，才能開始使用保單健檢)";
      // this.initGroupVue();

      // F5 重新整理方案

      // if(this.$store.state.userInfo.id === ''){
      //   setTimeout(() => {
      //     this.initGroupVue()
      //   }, this.$store.state.timeoutVal);
      // }else{
      //   this.initGroupVue()
      // }
      //this.getAgentEmail();
      this.initCommonlyUsedReport();
    },
    initData() {
      //getAllCurrentYearCoverageReportInfo
      this.pdfData = this.$store.state.PDFData;
      this.dragging = false;
      this.enabled = true;
      //是否滾動
      this.isScroll = false;
      //全選
      this.theadAll = false;
      //業務員ID
      // agidno: this.$store.state.userInfo.id,
      this.agidno = this.$store.state.userInfo.id;
      //業務員名字
      this.agentName = this.$store.state.userInfo.name;
      //過濾有勾選
      this.familyResultFilter = [];
      //全部報表
      this.familyInfoList = [];
      //全部報表Drag
      this.familyInfoListDrag = [];
      //是否為原住民
      this.isIndigenous = "N";
      //是否列印封面
      this.isCover = "N";
      //外幣
      this.isCurrency = "Y";
      //逐一保費一覽表，是否顯示表定保費、年繳保費的合計?
      this.isTotalPremium = "Y";
      //謹致
      this.sincerely = { users: [] };
      this.remoteDataMessage = "資料讀取中，請稍候...";
      this.users = [];
      this.roles = [
        {
          id: 0,
          name: "請選擇",
        },
        {
          id: 1,
          name: "先生",
        },
        {
          id: 2,
          name: "小姐",
        },
        {
          id: 3,
          name: "女士",
        },
        {
          id: 4,
          name: "保戶",
        },
        {
          id: 5,
          name: "小朋友",
        },
        {
          id: 6,
          name: "老師",
        },
        {
          id: 7,
          name: "教授",
        },
        {
          id: 8,
          name: "醫生",
        },
      ];
      this.sendEmailModalOpen = false;
      this.mvMaskOpen = false;
      this.agentData = {
        agentNm: "",
        mobile: "",
        corp_phone: "",
        email: "",
        corp_addr: "",
      };
      this.loading_1 = false;
      //自行輸入姓名
      this.selfSincerely = "";
      //控制外層選取報表
      this.isSelectPdf = false;
      //報表說明開關
      this.mvPdfInfoOpen = false;
      //報表說明標題
      this.pdfModalTitle = "";
      //報表說明種類
      this.pdfModalType = "";
      //要跳focus的位置
      this.focusPosition = "";
    },
    initCommonlyUsedReport() {
      let report = "00"; // 00：家庭保單健檢規劃書 01：尋保圖（個人總覽）02：321+1保藏圖
      getCommonlyUsedReport(this.agidno, report).then((result) => {
        if (result.header && result.header.status == "200" && result.data) {
          let reportList = result.data.map(function (item) {
            return item.report_type;
          });
          this.familyInfoList.forEach((item) => {
            if (reportList.includes(item.reportType)) {
              item.commonlyUsed = true;
            } else {
              item.commonlyUsed = false;
            }
          });
        }
        this.sortCommonlyUsed();
      });
    },
    sortCommonlyUsed() {
      let result = [];
      const reportTypeList = [
        "00",
        "18",
        "02",
        "03",
        "15",
        "01",
        "04",
        "05",
        "17",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "16",
        "20",
        "19",
        "21",
      ];

      if (this.familyInfoList.length > 0) {
        reportTypeList.forEach((type) => {
          for (let i = 0; i < this.familyInfoList.length; i++) {
            if (this.familyInfoList[i].reportType == type) {
              result.push(this.familyInfoList[i]);
              break;
            }
          }
        });
        this.familyInfoList = result;

        this.familyInfoList.sort(function (a, b) {
          return a.commonlyUsed && !b.commonlyUsed ? -1 : 1;
        });
      }
      this.$forceUpdate();
    },
    //檢查姓名
    checkInputName(agentData) {
      agentData.agentNm2 = agentData.agentNm2.replace(
        /[<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g,
        ""
      );
      if (this.stringBytes(agentData.agentNm2, false, 14) > 14) {
        agentData.agentNm2 = agentData.agentNm2.substring(
          0,
          this.stringBytes(agentData.agentNm2, true, 14)
        );
      }
    },
    //檢查手機
    checkInputMobile(agentData) {
      agentData.mobile2 = agentData.mobile2.replace(
        /[<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g,
        ""
      );
      if (this.stringBytes(agentData.mobile2, false, 10) > 10) {
        agentData.mobile2 = agentData.mobile2.substring(
          0,
          this.stringBytes(agentData.mobile2, true, 10)
        );
      }
    },
    // 編輯服務人員
    clickEdit(type) {
      if (type == "edit") {
        this.serverEdit = true;
        this.serverEditName = this.agentData.agentNm;
        this.serverEditPhone = this.agentData.mobile;
      } else if (type == "finish") {
        this.$validator.validateAll().then((el) => {
          if (el) {
            this.serverEdit = false;
            this.agentData.agentNm = this.serverEditName;
            this.agentData.mobile = this.serverEditPhone;
          }
        });
      }
    },
  },
  mounted() {
    this.API_BASEURL = this.getUrl();
    //初始化過後更新刷新參數
    this.$route.meta.reload = false;
    this.init();
    getServiceCenterData(this.agidno, { key: this.$route.query.key }).then(
      (result) => {
        this.users.push({ id: 0, name: result.holderName });
        this.agentData.agentNm = result.agentName;
        this.serviceCenterData = result;
        //謹致
        this.sincerely.users = this.users.map((map) => {
          return {
            id: map.id,
            name: map.name,
            role: 0,
            checked: false,
          };
        });
      }
    );
  },
  activated() {
    //判斷是否需刷新頁面資料
    if (this.$route.meta.reload) {
      new Promise((resolve) => {
        this.initData();
        resolve();
      }).then(() => {
        this.init();
        this.$route.meta.reload = false;
      });
    } else {
      //this.getAgentEmail();
    }
  },
  filters: {
    //手機格式化(加上'-')
    mobileFormat(srt) {
      if (!srt) {
        return "";
      } else {
        return (
          srt.substring(0, 4) +
          "-" +
          srt.substring(4, 7) +
          "-" +
          srt.substring(7)
        );
      }
    },
  },
  beforeDestroy() {
    //關閉可拖曳
    if (process.env.NODE_ENV !== "development") {
      document.ondragstart = function () {
        return false;
      };
    }
  },
};
</script>
<style lang="scss" scoped>
.pdfTitle {
  font-family: PingFangTC;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #027a39;
}
.fit-image {
  width: 100%;
  object-fit: cover;
  // height: 200px; /* only if you want fixed height */
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.activeInput {
  background-color: #fdeddc;
  border-radius: 6px;
}
.nactiveInput {
  background-color: rgba(234, 232, 232, 0.877);
  border-radius: 6px;
}

ol {
  margin-top: 0px;
}

.w-243 {
  width: 243px;
}

.w-300 {
  width: 300px;
}

.w-150 {
  width: 150px;
}

.pt-30 {
  padding-top: 30px;
}
.minHeight-120 {
  min-height: 120vh;
}
.verticalMiddle {
  vertical-align: middle;
}
.w-90 {
  width: 90px;
}
.w-148 {
  width: 148px;
}

.font-16 {
  font-size: 16px;
}
.font-20 {
  font-size: 20px;
}

.font-24 {
  font-size: 24px;
}

.pr-70 {
  padding-right: 70px;
}

.mb-10 {
  margin-bottom: 10px;
}
.mb-15 {
  margin-bottom: 15px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mb-30 {
  margin-bottom: 30px;
}
.mb-40 {
  margin-bottom: 40px;
}
.mb-60 {
  margin-bottom: 60px;
}

.mt-40 {
  margin-top: 40px;
}
.mt-20 {
  margin-top: 20px;
}

.ml-5p {
  margin-left: 5px;
}
.ml-10 {
  margin-left: 10px;
}
.ml-14 {
  margin-left: 14px;
}
.ml-15 {
  margin-left: 15px;
}
.ml-27 {
  margin-left: 27px;
}

.mr-14 {
  margin-right: 14px;
}
.mr-20 {
  margin-right: 20px;
}
.body-container {
  margin-bottom: 150px;
}
.noPDFListData {
  width: 208px;
  height: 22px;
  font-family: PingFangTC;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #989ca2;
}
.pdfBtn {
  border-radius: 4px;
  display: table;
  border-radius: 4px;
  background-color: #f5f5f5;
  vertical-align: middle;
  padding: 11px 19px;
  margin: 5px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  font-weight: 600;
}
.pdf-index {
  padding: 11px 5px;
  margin: 5px;
  font-size: 16px;
  text-decoration: none;
  font-weight: 600;
  width: 30px;
}

.baseLine {
  vertical-align: baseline !important;
}
.textTop {
  vertical-align: text-top !important;
}

.custModifyAgent {
  font-family: PingFangTC;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #027a39;
}

.custAgentTitle {
  margin-right: 15px;
  font-family: PingFangTC;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align-last: right;
  color: #323a45;
}

.custAgentContent {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #323a45;
}

.btn-common:hover {
  color: #ffffff;
  background-color: #9f9f9f;
}

.btn-common {
  margin-left: auto;
  border: none;
  color: #9f9f9f;
  font-weight: 700;
}

.btn-common:hover {
  color: #ffffff;
  background-color: #9f9f9f;
}

.btn-common-active {
  margin-left: auto;
  border: none;
  color: #f58818;
  font-weight: 700;
  background-color: #f5dec5;
  -webkit-transition: background-color 500ms linear;
  -ms-transition: background-color 500ms linear;
  transition: background-color 500ms linear;
}

.btn-common-active:hover {
  color: #ffffff;
  background-color: #ffb465;
}

.isTablet {
  hr {
    margin-top: 4px;
    margin-bottom: 4px;
  }
  .mb-15 {
    margin-bottom: 0px;
  }
  .mb-30 {
    margin-bottom: 18px;
  }
  .mb-40 {
    margin-bottom: 18px;
  }

  .rwd-mt {
    margin-top: 18px !important;
  }
  .mb-20 {
    margin-bottom: 12px;
  }
  .mb-60 {
    margin-bottom: 18px;
  }
  .mt-20 {
    margin-top: 12px;
  }
  .mt-40 {
    margin-top: 18px;
  }
  .pt-30 {
    padding-top: 12px;
  }
  .rwd-radio-block {
    margin-top: 3px;
    height: 25px;
  }
  .radio > input + label,
  .checkbox > input + label {
    height: 25px;
    line-height: 25px;
  }
  .checkboxMv > input + label {
    height: 25px;
    line-height: 25px;
  }
  .pdfBtn {
    padding: 0px 19px;
  }
  .pdf-index {
    padding: 0px 5px;
  }
}
.RectangleWidth-m {
  width: 205px;
}
.RectangleStyle {
  height: 40px;
  border-radius: 4px;
  box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.3);
  border: solid 1px #c2c4c7;
  background-color: #ffffff;
}
</style>